<template>
  <tmo-digital-header theme="light" v-if="isMagenta"></tmo-digital-header>
  <tmo-digital-header v-else brand="metro" client-id="metro"></tmo-digital-header>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'

import config from '@/config'

@Component
export default class TheHeader extends Vue {
  private get isMagenta () {
    return config.isMagenta
  }
}
</script>
